import {Location} from "history";
import StringUtil from "./StringUtil";
import $ from "jquery";

import {CodeData} from "common/codedata/source/CodeDataSource";
import codeDataStore from "common/codedata/store/CodeDataStore";
import message from "common/message/source/MessageSource";
import userStore from "common/user/store/UserStore";
import Axios, {AxiosRequestConfig} from "axios";
import TbSysTitle from "domain/main/sys/title/TbSysTitle";
import UIUtils from "./UIUtils";
import ObjectUtil from "./ObjectUtil";
import loadingStore from "../common/page/store/LoadingStore";
import menuStore from "../common/menu/store/MenuStore";

export default class CommonUtil {
    static get jexjs() {
        return window["jexjs"]
    }

    public static get contextPath() {
        return document.querySelector(`meta[name="X-Context-Path"]`)!.getAttribute("content") || "/";
    }

    public static get buildTimestamp() {
        return document.querySelector(`meta[name="X-Build-Timestamp"]`)!.getAttribute("content") || "";
    }

    /**
     * Executes an AJAX request with the given options.
     *
     * @param {object} option - Jex Request를 처리하기 위한 옴션
     * @param {string} option.url - 웹 서비스 ID
     * @param {any} [option.data] - 전송할 JSON Data
     * @param {HTMLFormElement} [option.form] - The HTML form. 비밀번호 입력항목인 경우 필수.
     * @param {any} [option.headers] - Http Request의 Header에 추가할 값.
     * @param {boolean} [option.progressBar] - Whether to show a progress bar during the request.
     *
     * @returns {Promise<any>} A promise that resolves with the response data or rejects with an error.
     */
    public static execute(option: {
        url: string;
        data?: any;
        form?: HTMLFormElement;
        headers?: any;
        progressBar?: boolean;
    }) {
        return new Promise((resolve, reject) => {
            this.jexjs.ajaxSetup({
                contextPath: "/",
                suffix: ".jct"

            });

            const activeMenu = menuStore.menuList?.filter(item => item.active).map(item => item.menuId);
           // console.log("activeMenu", activeMenu?.join(","))
            option.headers = Object.assign({}, option.headers);
            if(userStore.csrfToken) {
                option.headers[userStore.csrfToken.getHeaderName()] = userStore.csrfToken.getToken();
                option.headers["X-Active-Menu"] = activeMenu?.join(",");
            }


            const jexAjax = this.jexjs.createAjaxUtil(option.url);
            jexAjax.setting("headers", Object.assign(jexAjax.setting("headers"), option.headers))


            const requestData: any = {};

            if (option.form) {
                const e2eForm = $(option.form).find("input[type=password][data-enc=on]");
                if (e2eForm.length > 0) {
                    window["TK_makeEncData"](option.form)
                }
                const hidKeyData = option.form.hid_key_data?.value || "";
                const $form = $(option.form);
                const tempData = $form.serializeArray();

                tempData.forEach((v) => {
                    if (e2eForm.is("[name=" + v.name + "]")) {
                        requestData[v.name] = JSON.stringify({
                            value: v.value,
                            hidKeyData: hidKeyData,
                            e2e: $form.find("input[name=E2E_" + v.name + "]").val()
                        })
                    } else if (v.name.startsWith("hid_") || v.name.startsWith("E2E_")) {
                        // ignore
                    } else {
                        if (requestData[v.name])
                            requestData[v.name] = [...requestData[v.name], v.value];
                        else
                            requestData[v.name] = v.value;
                    }
                })
            }

            Object.assign(requestData, option.data);

            loadingStore.increaseCount();
            jexAjax.set(requestData);
            jexAjax.execute((dat: any) => {
                if(!option.url.includes("readSession")
                    && !option.url.includes("com_token")
                    && !option.url.includes("com_config")
                    && !option.url.includes("com_message")
                    && !option.url.includes("com_code")
                    && !option.url.includes("login")
                ) {
                    userStore.resetSession(false).then().catch();
                }

                loadingStore.decreaseCount();
                // @ts-ignore
                if (jexjs.isJexError(dat)) {
                    const errCode:string = this.jexjs.getJexErrorCode( dat );
                    const errMsg:string = this.jexjs.getJexErrorMessage( dat );
                    if(errCode === "NCFMSCSRF00") {
                        userStore.updateToken().then(() => {
                            this.execute(option)
                                .then(res => resolve(res))
                                .catch(rej => reject(rej));
                        })
                    }
                    else if(errCode === "NCFMSESSION") {
                        UIUtils.error(errMsg, errCode).then(() => {
                            window.location.replace("/");
                        });
                    }
                    else if(errCode === "JEXS3000001"
                        || errCode.startsWith("TKENC")
                    ) {
                        UIUtils.error(errMsg, errCode).then();
                    }

                    else {
                        reject(dat);
                    }
                } else {
                    resolve(dat);
                }
            });
        })
    }

    private static windowLocationReload: boolean;

    public static showAxiosError(error: any) {
        if (error == null) {
            return;
        }

        let invalidSession = false;
        let invalidToken = false;
        let errorMessage: string;
        let errorCode: string|undefined;

        if (error.COMMON_HEAD == null) {
            errorMessage = error;
        } else {
            // invalidSession = error.COMMON_HEAD.headers["x-invalid-session"] === "true";
            // invalidToken = error.COMMON_HEAD.headers["x-invalid-token"] === "true";

            if (invalidSession) {
                errorMessage = message.get("common.user.message.sessionTimeout", "오랫동안 사용하지 않아 로그아웃 되었습니다.");
            } else if (invalidToken) {
                errorMessage = message.get("common.message.invalidToken", "유효하지 않은 접근정보입니다.");
            } else if (error.COMMON_HEAD.MESSAGE && error.COMMON_HEAD.CODE) {
                errorMessage = error.COMMON_HEAD.MESSAGE;
                errorCode = error.COMMON_HEAD.CODE;
            } else {
                errorMessage = message.get("common.message.systemError", "시스템 에러가 발생했습니다.");
            }
        }

        if (!CommonUtil.windowLocationReload) {

            CommonUtil.windowLocationReload = invalidSession || invalidToken;
            UIUtils.error(errorMessage, errorCode).then().catch();
            // window.alert(errorMessage);
        }

        if (CommonUtil.windowLocationReload) {
            window.location.reload();
        }
    }

    public static getListPath(location?: Location) {
        const pathname = (() => {
            if (location != null) {
                return location.pathname;
            }

            if (StringUtil.isNotEmpty(window.location.hash)) {
                return window.location.hash;
            }

            return window.location.pathname;
        })();

        return pathname.substring(0, pathname.lastIndexOf("/") + 1);
    }

    public static toSortedTreeList(orgData: {
        MENU_ID: string;
        MENU_LEVEL: string;
        MENU_NM: string;
        MENU_PATH: string|null;
        UPPER_MENU_ID: string|null;
        AUTHOR_CODES: string;
    }[], key: string, upperKey: string): any[] {
        const treeData: any[] = [];
        const data = ObjectUtil.convertKeysToCamelCase<[]>(orgData);

        const addChildList = (upperValue: string | null) => {
            data.forEach((rowData) => {
                if (rowData[upperKey] === upperValue) {
                    treeData.push(rowData);
                    addChildList(rowData[key]);
                }
            });
        };

        addChildList(null);

        return treeData;
    }

    public static toHierarchyData(option: {
        sourceData: any[];
        itemKey: string;
        upperItemKey: string;
        childrenKey?: string;
        rootItem?: any;
        keyMapping?: { [targetKey: string]: string };
    }): any[] {
        const treeData: any[] = [];

        const addChildList = (upperValue: string | undefined | null, targetData?: any) => {
            option.sourceData.forEach((rowData) => {
                if (option.keyMapping != null) {
                    for (let targetKey in option.keyMapping) {
                        rowData[targetKey] = rowData[option.keyMapping[targetKey]];
                    }
                }

                if (rowData[option.upperItemKey] === upperValue) {
                    if (!option.childrenKey) {
                        treeData.push(rowData);
                        addChildList(rowData[option.itemKey]);
                    } else {
                        if (targetData[option.childrenKey] == null) {
                            targetData[option.childrenKey] = [];
                        }

                        targetData[option.childrenKey].push(rowData);

                        addChildList(rowData[option.itemKey], rowData);
                    }
                }
            });
        };

        if (option.rootItem != null) {
            option.rootItem[option.itemKey] = null;
            option.rootItem[option.upperItemKey] = undefined;

            treeData.push(option.rootItem);

            addChildList(null, option.rootItem);
        } else {
            addChildList(null, treeData);
        }

        return treeData;
    }

    private static uidIndex: number;
    public static getUid = () => {
        if (this.uidIndex == null) {
            this.uidIndex = 0;
        }
        const uidStr = StringUtil.leftPad(String(this.uidIndex++), 5, "0");

        if (this.uidIndex > 99999) {
            this.uidIndex = 0;
        }
        return new Date().getTime() + uidStr;
    };

    /**
     * 현재 시스템의 Running Mode를 가져온다.
     */
    //public static getRunningMode = () => process.env.REACT_APP_RUNNING_MODE || "PROD";

    public static getTitleList(
        dataList: {
            titleCode: string;
            titleLocale: string;
            titleCn: string;
        }[]
    ): TbSysTitle[] {
        const systemLocaleList = codeDataStore.get("/common/systemLocale");
        const dataMap: { [titleLocale: string]: TbSysTitle } = {};

        if (dataList != null) {
            dataList.forEach((data) => {
                dataMap[data.titleLocale] = new TbSysTitle(data);
            });
        }

        return systemLocaleList.map((systemLocaleCodeData: CodeData) => {
            if (dataMap[systemLocaleCodeData.code]) {
                return dataMap[systemLocaleCodeData.code];
            }

            return new TbSysTitle({titleLocale: systemLocaleCodeData.code});
        });
    }

    public static downloadTemplateFile(fileName: string, replaceFileName?:string) {
        if(!replaceFileName)
            replaceFileName = fileName;

        Axios({
            method: "GET",
            url: `/common/template/${fileName}`,
            responseType: "blob",
        }).then((response) => {
            //@ts-ignore
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                //@ts-ignore
                window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: response.headers["content-type"] }), "통계목(양식).xlsx");
            } else {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers["content-type"] }));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", replaceFileName as string);
                document.body.appendChild(link);
                link.click();
            }
        });
    }

    public static simpleExcelUpload(actionId: string, data?:{[key:string]:string}) {
        return new Promise((resolve, reject) => {

            const headers = {}
            if(userStore.csrfToken) {
                headers[userStore.csrfToken.getHeaderName()] = userStore.csrfToken.getToken()
            }
            window["$"].ajaxSetup({headers})

            const uploader = window.jexjs.plugin('upload', {
                url: actionId,
                name: 'FILE_NM',
                multiple: false,
                reset: true,
                event: {
                    loadstart: () => {
                    },
                    loadend: () => {
                    }
                }
            });

            if(data) {
                uploader.setData(data);
            }

            uploader.add((file, addFile, obj) => {
                if(!file.type.includes("officedocument.spreadsheetml") && !file.type.includes("ms-excel")) {
                    UIUtils.alert("Excel 파일만 업로드 가능합니다.").then();
                    return;
                }

                uploader.upload()
                    .done((data, jqXHR) => {
                        resolve(data)
                    })
                    .fail((data, textStatus, jqXHR) => {
                        reject(data)
                    });
            });
        });
    }

    /**
     *
     * @param option
     * @deprecated
     */
    public static axios(option?: { original?: boolean; progressBar?: boolean }) {
        console.warn("CommonUtil.axios", "이 메서드는 더이상 사용되지 않습니다.");

        const _axios = Axios.create({
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (option === undefined || option.progressBar === undefined || option.progressBar) {
            //loadProgressBar({ showSpinner: false }, _axios);
        }

        if (option != null && option.original === true) {
            return _axios;
        }

        _axios.interceptors.response.use(undefined, async (error) => {
            if (error.config && error.response && error.response.headers["x-invalid-token"] === "true") {
                // await userStore.updateToken();
                //
                // if (userStore.csrfToken == null) {
                //     return;
                // }
                //
                // error.config.headers[userStore.csrfToken.getHeaderName()] = userStore.csrfToken.getToken();
                // error.config.headers[userStore.csrfToken.getHeaderName() + "-Retry"] = "true";

                return _axios.request(error.config);
            }

            return Promise.reject(error);
        });

        _axios.interceptors.response.use(
            (response) => {
                // if (response.config.headers["x-read-session"] !== true) {
                //     userStore.resetSession(true).then().catch();
                // }

                return response;
            },
            (error) => {
                // if (error.response.config.headers["x-read-session"] !== true) {
                //     userStore.resetSession(true).then().catch();
                // }

                return Promise.reject(error);
            }
        );

        _axios.interceptors.response.use((response) => {
            if (response.config.responseType !== "blob" && response.config.responseType !== "arraybuffer") {
                return response;
            }

            const fileName = window.decodeURIComponent(
                (() => {
                    const contentDisposition = response.headers["content-disposition"];

                    if (contentDisposition != null) {
                        const contentDispositions = contentDisposition.split(";");

                        for (let i = 0; i < contentDispositions.length; i++) {
                            const contentArr = contentDispositions[i].split("=");

                            if (contentArr[0] != null && contentArr[1] != null && contentArr[0].trim() === "filename") {
                                const content = contentArr[1].trim();

                                if (
                                    (StringUtil.startsWith(content, `"`) && StringUtil.endsWith(content, `"`)) ||
                                    (StringUtil.startsWith(content, `'`) && StringUtil.endsWith(content, `'`))
                                ) {
                                    return content.substring(1, content.length - 2);
                                }

                                return content;
                            }
                        }
                    }
                })()
            );

            const blob = new Blob([response.data], {type: response.headers["content-type"]});

            //@ts-ignore
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                //@ts-ignore
                window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

            return response;
        });

        const getContextUrl = (url) => {
            if (url == null || url === "") {
                return window.location.pathname;
            }

            if (url.substring(0, 1) === "/") {
                //@ts-ignore
                return this.contextPath + url;
            }

            return url;
        };

        const uploadAllFiles = async (data?: any) => {
            const getFileUploads = (data?: any, fileUploads?: any[]): any[] => {
                if (fileUploads == null) {
                    fileUploads = [];
                }

                if (data != null) {
                    for (let key in data) {
                        if (key === "__upload_files__" && typeof data[key] === "function") {
                            fileUploads.push(data[key]);
                        }

                        if (typeof data[key] === "object") {
                            getFileUploads(data[key], fileUploads);
                        }
                    }
                }

                return fileUploads;
            };

            await Promise.all(getFileUploads(data).map((uploadFiles) => uploadFiles()));

            if (window["RAONKUPLOAD"] != null && typeof window["RAONKUPLOAD"].MultiTransferCustom === "function") {
                await new Promise((resolve: (value: unknown) => void, reject: (reason?: any) => void) => {
                    window["RAONKUPLOAD"].promiseFunctions = {resolve, reject};
                    window["RAONKUPLOAD"].MultiTransferCustom();
                });
            }
        };

        return {
            get: (url: string, config?: AxiosRequestConfig) => {
                if (config === undefined) {
                    config = {};
                }

                if (config.headers === undefined) {
                    config.headers = {};
                }

                config.headers["X-HTTP-Method-Override"] = "GET";

                if (config.data === undefined) {
                    config.data = null;
                }

                if (config.data?.excel?.download === true) {
                    config.responseType = "blob";
                }

                return _axios.post(getContextUrl(url), config.data, config);
            },
            post: async (url: string, data?: any, config?: AxiosRequestConfig) => {
                await uploadAllFiles(data);

                if (config === undefined) {
                    config = {};
                }

                if (data?.excel?.download === true) {
                    config.responseType = "blob";
                }

                return _axios.post(getContextUrl(url), data, config);
            },
            put: async (url: string, data?: any, config?: AxiosRequestConfig) => {
                await uploadAllFiles(data);

                if (config === undefined) {
                    config = {};
                }

                if (config.headers === undefined) {
                    config.headers = {};
                }

                config.headers["X-HTTP-Method-Override"] = "PUT";

                return _axios.post(getContextUrl(url), data, config);
            },
            patch: async (url: string, data?: any, config?: AxiosRequestConfig) => {
                await uploadAllFiles(data);

                if (config === undefined) {
                    config = {};
                }

                if (config.headers === undefined) {
                    config.headers = {};
                }

                config.headers["X-HTTP-Method-Override"] = "PATCH";

                return _axios.post(getContextUrl(url), data, config);
            },
            delete: (url: string, config?: AxiosRequestConfig) => {
                if (config === undefined) {
                    config = {};
                }

                if (config.headers === undefined) {
                    config.headers = {};
                }

                config.headers["X-HTTP-Method-Override"] = "DELETE";

                if (config.data === undefined) {
                    config.data = null;
                }

                return _axios.post(getContextUrl(url), config.data, config);
            },
        };
    }

    //사업자번호 체크
    //사용 예) if(!bizNoCheck(bizNo)) return;
    public static bizNoCheck(bizNoVal:string) {
		let passFlag = true;
        if(StringUtil.defaultString(bizNoVal) !== '') {
            const inBizNo = bizNoVal.replace(/-/ig, '');
            if(inBizNo.length !== 10) {
                UIUtils.alert('사업자번호를 정확히 입력해주세요.').then();
                passFlag = false;
            }
        }
		return passFlag;
	}

    //사용용도에 따른 과제분류(대분류, 소분류) 값 매핑
    public static suppSizeMappingVal(code:string) {
        let retVal = "";
        if(StringUtil.defaultString(code) !== '') {
            if(code === 'A0'){       //상생협력 성과의 공평한 배분에 관한 사업
                retVal = "1";
            }else if(code === 'B0'){ //기술협력 촉진 사업
                retVal = "2";
            }else if(code === 'C0'){ //인력교류 확대 사업
                retVal = "3";
            }else if(code === 'D0'){ //환경경영협력 촉진 사업
                retVal = "4";
            }else if(code === 'E0'){ //임금격차 완화 및 일자리 창출 지원 사업
                retVal = "5";
            }else if(code === 'F0'){ //상생협력기금의 조성ㆍ운용 및 관리를 위한 경비
                retVal = "6";
            }else if(code === 'G1'){ //중소기업의 생산성 향상을 위한 지원 사업
                retVal = "7";
            }else if(code === 'G2'){ //중소기업의 기술 보호 지원 사업
                retVal = "8";
            }else if(code === 'G3'){ //중소기업 및 벤처기업의 창업 지원 사업
                retVal = "9";
            }else if(code === 'G4'){ //국내외 판로 확대를 위한 공동 협력 사업
                retVal = "10";
            }else if(code === 'G5'){ //대ㆍ중소기업 간 거래 공정화 지원 사업
                retVal = "11";
            }else if(code === 'G6'){ //동반성장 기반 구축 및 문화 확산에 관한 사업
                retVal = "12";
            }else if(code === 'G7'){ //벤처투자조합에 대한 출자
                retVal = "13";
            }else if(code === 'G8'){ //중소기업 근로자의 복리 증진을 위한 지원 사업
                retVal = "15";
            }else if(code === '99'){ //기부금 사용용도 미지정
                retVal = "14";
            }
        }
        return retVal;
    }
    
}